module.exports = __webpack_public_path__ + "img/point.26849332.svg";